import { Caption } from '@xo-union/tk-ui-typography';
import React from 'react';
import styles from './headline.scss';
import { Item, ItemProps } from './Item';

interface Props extends Omit<ItemProps, 'children'> {
  photoPath: string;
  title?: string;
}

export const PhotoItem: React.FC<Props> = ({ photoPath, onClick, title = 'Photo', ...rest }) => (
  <Item onClick={onClick} {...rest}>
    <div className={styles.container}>
      <Caption className={styles.title}>{title}</Caption>
      <img className={styles.img} src={photoPath} alt="" />
    </div>
  </Item>
);
